@if (isLoading) {
  <loader [config]="{
    fullScreen: false,
    overlay: true,
    type: 'spinner',
    size: 'md',
    text: 'Loading...'
  }"/>
}
<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <introducer-form
        [introducer]="introducer"
        (onSavedData)="onSavedData($event)"
      />
    </div>
  </div>
</div>
